export const qd = [
    {
        id: 1,
        question: "According to PrismaX, what is the fundamental problem preventing mainstream robot adoption?",
        options: [
            {
                id: 'A',
                text: "Current AI models lack sufficient accuracy for autonomous operation, creating economic justification\n" +
                    "problems for robot ownership",
                correct: true
            },
            {
                id: 'B',
                text: "Hardware manufacturing costs remain prohibitively expensive despite\n" +
                    "advances in dexterous manipulators and quasi-direct-drive actuators",
                correct: false
            },
            {
                id: 'C',
                text: " Teleoperator training programs are inadequately developed and lack standardization across different\n" +
                    "robotics platforms and environments",
                correct: false
            },
            {
                id: 'D',
                text: "Data collection infrastructure is fragmented across vendors,\n" +
                    "preventing aggregation necessary for large-scale machine learning development",
                correct: false
            }
        ]
    },
    {
        id: 2,
        question: "What is the primary purpose of the Quick Return Bonus (QRB) mechanism in PrismaX's\n" +
            "teleoperation protocol?",
        options: [
            {id: 'A', text: "To reduce operator training time by automatically adjusting task difficulty based on individual\n" +
                    "performance metrics", correct: false},
            {id: 'B', text: "To incentivize speed and discover skilled operators while creating premium data traces for AI\n" +
                    "companies", correct: true},
            {id: 'C', text: "To eliminate specialized VR hardware needs by providing financial compensation that offsets\n" +
                    "equipment costs for participants", correct: false},
            {id: 'D', text: "To automatically validate data quality without human oversight by correlating completion speed with\n" +
                    "accuracy benchmarks", correct: false}
        ]
    },
    {
        id: 3,
        question: "How does PrismaX differentiate between the two main categories of data in its marketplace\n" +
            "ecosystem?",
        options: [
            {id: 'A', text: "Real-time data is processed immediately for live applications, while historical data is stored for training", correct: false},
            {id: 'B', text: "Visual data captures camera feeds and sensors, while behavioral data records operator actions and\n" +
                    "decisions", correct: false},
            {id: 'C', text: "Network-owned data is community-controlled and sold via token-burn, while customer-owned uses\n" +
                    "fee-based transactions", correct: true},
            {id: 'D', text: "Teleoperator-generated data comes from human-controlled robots, while autonomous data comes\n" +
                    "from self-operating systems", correct: false}
        ]
    },
    {
        id: 4,
        question: "What creates the self-reinforcing cycle of improvement in PrismaX's data-model-teleop flywheel\n" +
            "mechanism?",
        options: [
            {id: 'A', text: "Higher token prices attract robot purchasers, generating network fees that fund improved hardware\n" +
                    "development", correct: false},
            {id: 'B', text: "More robots generate valuable datasets, enhancing AI intelligence, which improves robot productivity\n" +
                    "and viability", correct: true},
            {id: 'C', text: "Faster teleoperators reduce latency requirements, decreasing costs, attracting customers and\n" +
                    "increasing overall revenue", correct: false},
            {id: 'D', text: "Guild formation improves operator training, reducing errors, eliminating dependency on AI model\n" +
                    "assistance systems", correct: false}
        ]
    },
    {
        id: 5,
        question: "What distinguishes Stage III from earlier stages in PrismaX's evolutionary roadmap?",
        options: [
            {id: 'A', text: "Introduction of visual data collection capabilities and establishment of guild-based investment\n" +
                    "structures for robots", correct: false},
            {id: 'B', text: "Transition to real-world task completion by experienced operator fleets serving actual customers\n" +
                    "versus research", correct: false},
            {id: 'C', text: "Achievement of high robot autonomy with production-scale services and decentralized inference for\n" +
                    "foundation models", correct: true},
            {id: 'D', text: "Focus on teleoperator skill development bridging simulation training environments and real-world\n" +
                    "deployment scenarios", correct: false}
        ]
    }
];
